import type { PaymentMethodLogo } from '../types';

export const DEFAULT_PAYMENT_METHOD_LOGOS: PaymentMethodLogo[] = [
  { id: 'mercado-pago', name: 'Mercado Pago', logo_type: 'logodev_name', logo_value: 'Mercado Pago', enabled: 1, sort_order: 10 },
  { id: 'nequi', name: 'Nequi', logo_type: 'logodev_name', logo_value: 'Nequi', enabled: 1, sort_order: 20 },
  { id: 'davivienda', name: 'Davivienda', logo_type: 'logodev_name', logo_value: 'Davivienda', enabled: 1, sort_order: 30 },
  { id: 'bancolombia', name: 'Bancolombia', logo_type: 'logodev_name', logo_value: 'Bancolombia', enabled: 1, sort_order: 40 },
];
